import React,{useEffect,useRef} from "react";
import SmoothScroll from "../components/Lenis";
import NavBar from "../components/NavBar";
import img from "../assets/AboutImg.svg"
import Founder from "../components/Founder";
import Footer from "../components/Footer";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const About = ()=>{
    SmoothScroll();

    const sec1 = useRef(null);
    const sec2 = useRef(null);
    const sec3 = useRef(null);
    const img1 = useRef(null);
    const sec4 = useRef(null);

    useEffect(() => {
        gsap.set(sec1.current, { opacity: 0, y: 100 });
        gsap.set(sec2.current, { opacity: 0, y: 100 });
        gsap.set(sec3.current, { opacity: 0, y: 100 });
        gsap.set(img1.current, { opacity: 0, y: 100 });
        gsap.set(sec4.current, { opacity: 0, y: 100 });

        gsap.to(img1.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: img1.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
        gsap.to(sec4.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec4.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sec3.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec3.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sec1.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec1.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sec2.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec2.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);

    return(
        <div className="bg-black overflow-hidden">
            <NavBar />
            <section className="w-full font-guton pt-20 bg-whiteExtra pb-10 font-guton ">
                <div className="flex flex-col w-90 mx-auto max-w-[1440px]">
                    <div ref={sec1} className="flex">
                        <div className="hiddin md:w-30"></div>
                        <div className="flex-col w-full md:w-70">
                            <p className="text-red text-16 md:text-14 xl:text-17 font-semibold">OUR MISSION</p>
                            <p className="text-22 md:text-23 leading-22 xl:text-40 tracking-[-1.5px] xl:leading-40 w-90">Our vision is to become a trusted, community-driven partner that families rely on to transform their educational journeys abroad. We will build a network where students feel supported & connected</p>
                            <p className="text-red text-16 md:text-14 xl:text-17 font-semibold mt-10">OUR VISION</p>
                            <p className="text-22 md:text-23 leading-22 xl:text-40 tracking-[-1.5px] xl:leading-40">To be a comprehensive partner for students seeking to study abroad, simplifying every step from <strong>application to relocation.</strong> Empowering students to access global educational seamlessly</p>
                        </div>
                    </div>
                    <div ref={sec2} className="flex flex-col mt-20 md:mt-28 mb-16">
                        <p className="text-red text-16 md:text-14 xl:text-17 font-semibold">OUR VALUES</p>
                        <div className="flex justify-between flex-wrap md:flex-nowrap text-25 xl:text-44">
                            <p className="w-45 md:w-auto font-medium  tracking-[-2px] my-4">Integrity</p>
                            <p className="mr-auto md:w-auto md:mx-auto font-medium tracking-[-2px] my-4">Empowerment</p>
                            <p className="w-45 md:w-auto md:mx-auto font-medium tracking-[-2px] my-4">Excellence</p>
                            <p className="mr-auto md:w-auto md:mx-auto  font-medium tracking-[-2px] my-4">Change Makers</p>
                        </div>
                    </div>
                    <img ref={img1} src={img} alt="" />
                    <h2 ref={sec3} className="text-36 md:text-35 xl:text-62 tracking-[-3px] font-semibold mt-10 mb-5">We are Estudy</h2>
                    <p ref={sec4} className="text-18 leading-18 md:text-13 md:leading-14 xl:text-23 xl:leading-24 tracking-[-1px]">We are Estudy, a company dedicated to guiding students through the transformative journey of studying abroad. From university applications to settling into a new country, we make the process smooth and easy to follow.<br /><br/> At Estudy, we aim to be a trusted partner for students and families, empowering individuals to access global education and create a future full of possibilities.</p>
                </div>
            </section>
            <Founder />
            <Footer />
        </div>

    )
}

export default About;